import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface PublicGuardProps {
    children: React.ReactNode;
}

const PublicGuard = ({ children }: PublicGuardProps) => {
    const { isAuthenticated } = useSelector((state: any) => state.auth);

    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default PublicGuard;
